// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 1533 ? "asset-media-preview" : chunkId) + "." + {"1215":"879b7db5","1533":"879b7db5","3241":"9a771c5c","3636":"879b7db5","7638":"e0225952","7802":"879b7db5","8342":"879b7db5"}[chunkId] + ".chunk.css";
};